import type { TOC } from '@ember/component/template-only';
import { concat, fn } from '@ember/helper';
import { on } from '@ember/modifier';
import type { Task } from 'ember-concurrency';
import perform from 'ember-concurrency/helpers/perform';
import t from 'ember-intl/helpers/t';
import type CareGiver from 'parog-web/models/care-giver';
import type { S as LabeledInputSig } from 'ui-kit/components/changeset/labeled-input';
import LabeledInput from 'ui-kit/components/changeset/labeled-input';

interface S {
  Args: Pick<
    LabeledInputSig['Args'],
    'changeset' | 'isMandatory' | 'propertyName'
  > & {
    name?: LabeledInputSig['Args']['placeholder'];
    onSelected: (index: number) => void;
    propertyName?: unknown;
    query: Task<CareGiver[], unknown[]>;
    suggestionsAreVisible?: unknown;
  };
  Blocks: { loader: [] };
}

const SearchableField: TOC<S> = <template>
  <LabeledInput
    @changeset={{@changeset}}
    @labelName={{@name}}
    @placeholder={{@name}}
    @propertyName={{@propertyName}}
    @isMandatory={{@isMandatory}}
    class='flex flex-col'
    {{on 'input' (perform @query @propertyName)}}
  >
    {{yield to='loader'}}
    {{#unless @query.isRunning}}
      <div class='ui card {{if @suggestionsAreVisible "w-full" "hidden"}}'>
        {{#each @query.lastSuccessful.value as |careGiver index|}}
          <div
            class='cursor-pointer p-[0.5em] hover:bg-[rgba(0,0,0,0.03)]'
            role='button'
            data-test-care-giver={{careGiver.lastName}}
            {{on 'click' (fn @onSelected index)}}
          >
            {{concat
              careGiver.firstName
              ' '
              careGiver.lastName
              ' - '
              (t (concat 'careGiver.role.' careGiver.role))
            }}
          </div>
        {{/each}}
      </div>
    {{/unless}}
  </LabeledInput>
</template>;

export default SearchableField;
